import { render, staticRenderFns } from "./FileManager.vue?vue&type=template&id=2676947e&scoped=true"
import script from "./FileManager.vue?vue&type=script&lang=js"
export * from "./FileManager.vue?vue&type=script&lang=js"
import style0 from "./FileManager.vue?vue&type=style&index=0&id=2676947e&prod&lang=scss&scoped=true"
import style1 from "./FileManager.vue?vue&type=style&index=1&id=2676947e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2676947e",
  null
  
)

export default component.exports